const tooltips = {
  emailsablon: 'A funkció célja, hogy a szállító rendelés küldéséhez szükséges email sablon létrehozható, karbantartható legyen.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
